export function buildPositionChangesFromAutoPositions(tasks, autoPos) {
  const positionChanges = [];
  tasks.forEach((task) => {
    const pos = autoPos[task.id];
    if (pos && Number.isFinite(pos.x) && Number.isFinite(pos.y)) {
      positionChanges.push({
        taskId: task.id,
        position: pos,
        oldPosition:
          task.x !== undefined && task.y !== undefined ? { x: task.x, y: task.y } : null,
      });
    }
  });
  return positionChanges;
}

export function buildPositionChangesFromCustomMap(tasks, positionMap) {
  const positionChanges = [];
  tasks.forEach((task) => {
    const pos = positionMap[task.id];
    if (pos && Number.isFinite(pos.x) && Number.isFinite(pos.y)) {
      positionChanges.push({
        taskId: task.id,
        position: pos,
        oldPosition:
          task.x !== undefined && task.y !== undefined ? { x: task.x, y: task.y } : null,
      });
    }
  });
  return positionChanges;
}
